import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, catchError, of, switchMap, tap, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AuthResponse, LoginRequest } from './auth.models';
import { TokenService } from './token.service';

@Injectable({ providedIn: 'root' })
export class AuthService {
  private readonly http = inject(HttpClient);
  private readonly tokenService = inject(TokenService);

  login(request: LoginRequest): Observable<AuthResponse> {
    return this.http.post<AuthResponse>(`${environment.apiUrl}/auth/login`, request).pipe(
      catchError(() => this.http.post<AuthResponse>(`${environment.apiUrl}/clientes/auth/login`, request)),
      tap((response) => this.tokenService.saveSession(response))
    );
  }

  changePassword(payload: { passwordActual: string; passwordNueva: string; confirmarPassword: string }): Observable<string> {
    return this.http.post(`${environment.apiUrl}/auth/cambiar-password`, payload, { responseType: 'text' });
  }

  acceptDataPolicy(): Observable<{ message: string }> {
    return this.http.post<{ message: string }>(`${environment.apiUrl}/auth/aceptar-politica-datos`, {});
  }

  requestPasswordReset(email: string): Observable<{ message: string; resetUrl?: string }> {
    return this.http.post<{ message: string; resetUrl?: string }>(`${environment.apiUrl}/auth/recuperar-password`, { email });
  }

  resetPassword(payload: { token: string; passwordNueva: string; confirmarPassword: string }): Observable<{ message: string }> {
    return this.http.post<{ message: string }>(`${environment.apiUrl}/auth/reset-password`, payload);
  }

  logout(): void {
    this.tokenService.clear();
  }
}
